import { Vue } from "~/common/vue";
import InformationModal from "~/components/layouts/atoms/InformationModal";

document.addEventListener("DOMContentLoaded", () => {
  new Vue({
    el: "#common_information",
    components: { InformationModal }
  });
});
